import axios from "axios";
import { headers } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchBecomeMemberBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-member-become-a-member-banners?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchFormRequirement = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-member-become-a-member-form-requirements?sort=Order%3Aasc&populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchBenefitsMemberBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-member-benefits-of-member-banners?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchListMemberBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-member-list-of-all-members-banners?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchBecomeMemberFrom = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-member-become-a-member-descriptions?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchMemberShipType = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-member-become-a-member-membership-types?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchBenefitsMemberFrom = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-member-benefits-of-member-descriptions?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchBenefitsMemberTabs = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-member-benefits-of-member-tabs?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchMemberLists = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-users?populate[Profile_Picture][populate]=*&populate[Payment_Reciept][populate]=*&populate[frcsit_user_operations][populate]=*&populate[bi_frcsit_user_upload][populate]=*&sort=createdAt:desc`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const getToken = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-tokens?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};